import BaseController   from "controllers/external/account/base"
import FilterForm       from "servos/filterForm"
import { placesUri }    from "servos/googlePlaces"
import ExternalProjectSearchWidget from "widgets/externalProjectSearchWidget"

class Controller extends BaseController {
  call() {
    super.call()
    bindShowLinks.call(this)
    bindFilterProject.call(this)
    bindExternalProjectSearchWidget.call(this)
  }
};

let bindExternalProjectSearchWidget = function() {
  let elem = this.root
  this.externalProjectSearchWidget = new ExternalProjectSearchWidget(elem)
}

let bindFilterProject = function() {
  this.filterForm = new FilterForm(this.root.find('.filtrable'))

  // this.on('select2-changed', (e) => {
  //   this.filterForm.send()
  // });

  this.filterForm.send()
}

let bindShowLinks = function() {
  this.root.on('click', '.project-item', (e) => {
    window.location = e.currentTarget.dataset.url
  })
}

export default Controller;
